import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=4141d87f&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4141d87f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4141d87f')) {
      api.createRecord('4141d87f', component.options)
    } else {
      api.reload('4141d87f', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=4141d87f&scoped=true&", function () {
      api.rerender('4141d87f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/reporting-channel/reports/identification/Index.vue"
export default component.exports